import { render, staticRenderFns } from "./lawsList.vue?vue&type=template&id=226b1a96&scoped=true"
import script from "./lawsList.vue?vue&type=script&lang=js"
export * from "./lawsList.vue?vue&type=script&lang=js"
import style0 from "./lawsList.vue?vue&type=style&index=0&id=226b1a96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226b1a96",
  null
  
)

export default component.exports